<h5 mat-dialog-title> {{isNotesView ? 'Add Note':
  'Add Comments'}} </h5>
<div mat-dialog-content>
  <textarea (keyup)="commments($event)" rows="4" cols="50" class="form-control my-3" formControlName="comments"
    placeholder="Enter comments"></textarea>
</div>
<div mat-dialog-actions class="float-right">
  <button type="button" class="btn btn-custom_primary ml-2 mr-2" (click)="closeDialog(true)">Cancel</button>
  <button type="button" *ngIf="isNotesView ; else commentsActions"
    class="btn btn-custom_primary ml-2 mr-2 color-orange " id="inv_setup_save" data-backdrop="static"
    data-keyboard="false" (click)="closeDialog(false)" [disabled]="comments.invalid">Add</button>
 
  <ng-template #commentsActions>
    <button type="button" [disabled]="comments.invalid" *ngIf="isApproved;else rejected"
      class="btn btn-custom_primary ml-2 mr-2 color-orange " id="inv_setup_save" data-backdrop="static"
      data-keyboard="false" (click)="closeDialog(false)">Approve</button>
    <ng-template #rejected>
      <button type="button" [disabled]="comments.invalid" class="btn btn-custom_primary ml-2 mr-2 deleteButton"
        (click)="closeDialog(false)">
        Reject </button>
    </ng-template>
 
  </ng-template>
 
</div>